// extracted by mini-css-extract-plugin
export var contrastLow = "_27-1";
export var externalLink = "_27-2";
export var externalLinkIcon = "_27-3";
export var link = "_27-0";
export var linkLabel = "_27-4";